import React from 'react';
import {connect} from 'react-redux';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';

import './styles.less';

const mapStateToProps = (state, props) => ({
    ...state.seoLinkpile,
    isMobile: state.config.isMobile,
    site: state.config.site.name,
    forceExpanded: props.forceExpanded,
});

export const SeoLinkpileComponent = (props) => (
    <CollapsibleLinkpile {...props} />
);

export const SeoLinkpile = connect(mapStateToProps)(SeoLinkpileComponent);
SeoLinkpile.displayName = 'SeoLinkpile';

export default SeoLinkpile;
